<template lang="pug">
div
  v-toolbar(flat)
    v-list.pa-0.text-xs-center.cp
      router-link(:to='{ name: "home" }', tag='div')
        v-layout(align-center, justify-center)
          img(src='/images/dfs-logo-light.svg')

  v-layout(column, justify-space-between, style='height: calc(100vh - 65px)')
    v-list.pa-3
      template(v-if='!$store.getters["organization/isFirstUse"]')
        v-list-tile(:to='{ name: "leases" }')
          v-list-tile-action
            v-icon fas fa-file-alt
          v-list-tile-content
            v-list-tile-title Alle aanvragen

        // v-list-tile(:to='{ name: "kvk api costs" }')
          v-list-tile-action
            v-icon show_chart
          v-list-tile-content
            v-list-tile-title KvK API Kosten

        v-list-tile(:to='{ name: "calculations" }')
          v-list-tile-action
            v-icon fas fa-calculator
          v-list-tile-content
            v-list-tile-title Berekenen

        v-list-tile(:to='{ name: "dealers" }')
          v-list-tile-action
            v-icon fas fa-user
          v-list-tile-content
            v-list-tile-title Aangesloten dealers

        v-list-tile(:to='{ name: "websites" }')
          v-list-tile-action
            v-icon fas fa-star
          v-list-tile-content
            v-list-tile-title Websiteprofielen

        v-list-tile(:to='{ name: "tools" }')
          v-list-tile-action
            v-icon fas fa-wrench
          v-list-tile-content
            v-list-tile-title Tools

        v-list-tile(:to='{ name: "notifications" }')
          v-list-tile-action
            v-icon fas fa-bell
          v-list-tile-content
            v-list-tile-title Notificaties

      v-list-tile(:to='{ name: "settings" }')
        v-list-tile-action
          v-icon fas fa-cogs
        v-list-tile-content
          v-list-tile-title Instellingen

    //- .costs
      v-layout(column)
        b.primary--text Aanvragen deze maand
        v-layout(justify-space-between)
          span Krediet
          span 15
        v-layout(justify-space-between)
          span Financial Lease
          span 4
        v-layout.mt-4(justify-space-between)
          b Totaal
          b 19
        //- v-layout(align-end)
          small Prijzen zijn excl. 21% BTW
</template>

<script>
export default {

}
</script>

<style lang="scss">
@import "src/styles/variables";

.costs {
  padding: $g;
  border-top: 1px solid $light;
  border-bottom: 1px solid $light;
  color: white;

  & > div {
    max-width: 230px;
    margin-left: $g;
  }

  small {
    color: $gray3;
    font-size: 10px;
    text-align: right;
    width: 100%;
  }
}

.v-list {
  padding-left: 0 !important;

  .v-list__tile {
    .v-list__tile__action {
      justify-content: center;
    }

    .v-list__tile__content {
      .v-list__tile__title {
        font-size: 15px;
      }
    }
  }
}
</style>
